import { DatabaseIdTypes } from "../../Enums/ChoiceEnums";
import { postObject, fullUrl, combinePaths } from "../ChoiceApi";

// Add an audit log entry.  Commonly used to log View actions for a screen
export async function importCCD(xmlCCD: string, patientId: number): Promise<boolean | undefined>
{
    return postObject(`api/CCD/${patientId}`, { xmlCCD: xmlCCD });
}

// Get the URL to a page that displays a CCD in Surescripts
export function surescriptsCcdViewerUrl(docUrl: string, patientId: number): string{
    const route = combinePaths([`App/CCD/Surescripts/Viewer/${patientId}/`, docUrl], false);
    return fullUrl(route);
}

export function choiceCcdViewerUrl(id: number, idType?: DatabaseIdTypes): string{
    return fullUrl(`App/CCD/Viewer/${id}/${idType ?? DatabaseIdTypes.ccd_id}`);
}